export default __webpack_public_path__ + "2781dd79b053b047434d3f443dd6c931.png";